module.exports = __webpack_public_path__ + "assets/sureTips.014e6310868995048387d8e67d150c17.png";